import React from "react";
import { HelpCircle } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { notaAiuto } from "@/lib/noteAiuto";

const slug = (campo) => campo.replace(/[._]/g, "-");

// Sprint 13/14 — "?" accanto al campo, solo se il dizionario ha un testo; il titolo è l'etichetta del campo
export function NotaAiuto({ campo, titolo }) {
  const testo = notaAiuto(campo);
  if (!testo) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label={`Aiuto: ${titolo}`}
          className="ml-1 inline-flex align-middle text-slate-400 hover:text-[#0F4C81] transition-colors"
          data-testid={`nota-aiuto-${slug(campo)}`}>
          <HelpCircle className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 text-xs leading-relaxed" data-testid={`nota-aiuto-${slug(campo)}-testo`}>
        <div className="font-semibold text-slate-800 mb-1">{titolo}</div>
        <p className="text-slate-600">{testo}</p>
      </PopoverContent>
    </Popover>
  );
}

export function CampoLabel({ campo, className = "text-xs", children }) {
  const titolo = typeof children === "string" ? children.trim() : children;
  return (
    <div className="flex items-center">
      <Label className={className}>{children}</Label>
      <NotaAiuto campo={campo} titolo={titolo} />
    </div>
  );
}
